import { CHART_RECORD_REMOVAL_REASONS } from '@behuman/core-contract'

export type ChartRecordRemovalReason = (typeof CHART_RECORD_REMOVAL_REASONS)[number]

/**
 * The words a removal reason is shown in, for EVERY reader of one.
 *
 * These lived inside TypedDeleteConfirmModal, the screen that writes the reason. Nothing
 * else could reach them, so the activity modal printed the stored slug and a clinician who
 * had picked "Incorrect or incomplete document" was later told the removal happened for
 * "incorrect-incomplete". A justification the product required someone to give should read
 * back in the words it was asked for.
 *
 * These are what a READER is shown. The picker adds its own instruction to the writer (see
 * REMOVAL_REASON_OPTIONS) — "require explanation" tells the person choosing what happens
 * next and says nothing about the removal, so it does not belong in the record.
 */
export const CHART_RECORD_REMOVAL_REASON_LABELS: Record<ChartRecordRemovalReason, string> = {
  'wrong-patient': 'Uploaded to the wrong patient',
  duplicate: 'Duplicate document',
  'incorrect-incomplete': 'Incorrect or incomplete document',
  'test-training': 'Test/training document',
  other: 'Other',
}

/**
 * The label for a stored reason, or the stored value when it is not one this build knows.
 *
 * An unknown slug is shown rather than dropped: it is what the record actually says, and a
 * blank where a required justification belongs is worse than an unpolished one.
 */
export function chartRecordRemovalReasonLabel(reason: string): string {
  return CHART_RECORD_REMOVAL_REASON_LABELS[reason as ChartRecordRemovalReason] ?? reason
}
